(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/ui/form/assets/javascripts/forms.js') >= 0) return;  svs.modules.push('/components/ui/form/assets/javascripts/forms.js'); 'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

svs.ui = svs.ui || {};
svs.ui.forms = svs.ui.forms || {};

svs.ui.Forms = function () {
  function Forms(options) {
    _classCallCheck(this, Forms);

    this.initForm(options.el);
  }

  _createClass(Forms, [{
    key: "initForm",
    value: function initForm(el) {
      var formEl = document.querySelector(".".concat(el));
      var inputs = formEl.querySelectorAll('input, textarea');
      var selects = formEl.querySelectorAll('select');

      for (var i = 0; i < inputs.length; i++) {
        if (!svs.core.detect.browser.msie() && !svs.core.detect.browser.ie()) {
          var desc = "".concat(inputs[i].id, "_desc");
          inputs[i].closest('.control-group') && inputs[i].closest('.control-group').querySelector('.info-message') && inputs[i].closest('.control-group').querySelector('.info-message').setAttribute('id', desc);
        }

        if (inputs[i].value && inputs[i].classList.contains('js-input')) {
          inputs[i].classList.add('input-valid');
          formEl.querySelector(".js-label-".concat(inputs[i].id)).classList.remove('hide-label');
        }

        inputs[i].oninput = function (e) {
          if (e.currentTarget.classList.contains('js-input') && !svs.core.detect.browser.msie() && !svs.core.detect.browser.ie() && e.target.closest('.control-group').classList.contains('error')) {
            e.target.closest('.control-group').classList.remove('error');
          }

          if (e.target.value || e.target.validity.badInput) {
            e.target.classList.add('input-valid');
          } else {
            e.target.classList.remove('input-valid');
          }
        }; 


        if (inputs[i].type === 'password') {
          (function () {
            var input = inputs[i];
            var sufxEl = input.nextElementSibling.querySelector('.input-sufx');
            sufxEl.style.cursor = 'pointer';
            input.style.width = "".concat(input.clientWidth - input.nextElementSibling.querySelector('.input-trailing').clientWidth, "px");
            sufxEl.addEventListener('click', function (e) {
              e.preventDefault();
              e.stopImmediatePropagation();
              e.stopPropagation();
              var openEye = e.target.offsetParent.querySelector('.icon-eye');
              var closedEye = e.target.offsetParent.querySelector('.icon-eye-closed');

              if (closedEye) {
                closedEye.classList.add('icon-eye');
                closedEye.classList.remove('icon-eye-closed');
                input.type = 'text';
              } else if (openEye) {
                openEye.classList.add('icon-eye-closed');
                openEye.classList.remove('icon-eye');
                input.type = 'password';
              }

              e.target.closest('.control-group').querySelector('.js-input').focus();
            });
          })();
        }
      } 


      for (var _i = 0; _i < selects.length; _i++) {
        selects[_i].onchange = function (e) {
          if (e.target.classList.contains('select-v2') && !svs.core.detect.browser.msie() && !svs.core.detect.browser.ie() && e.target.closest('.control-group').classList.contains('error')) {
            e.target.closest('.control-group').classList.remove('error');
          }
        };
      }
    }
  }]);

  return Forms;
}();
 })(window);